import { AnyAction } from 'redux';
import { App, GisDatenVHV, VhvVorbelegungdaten } from '@ps20-frontend/frontend-models';
import {
  GisDatenErmitteltPayload,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const gisDatenReducer = function (
  sectionState: GisDatenVHV = null,
  action: AnyAction,
  state: IAppState,
): GisDatenVHV {
  switch (action.type) {
    case VhvActions.PLZ_CHANGED:
    case VhvActions.ORT_CHANGED:
    case VhvActions.STRASSE_CHANGED:
    case VhvActions.HAUSNUMMER_CHANGED:
    case VhvActions.MAP_COORDINATES_VHV_CHANGED_EINGABE:
    case VhvActions.MAP_COORDINATES_VHV_CHANGED_ANGEBOT: {
      return null;
    }
    case GlobalActions.GISDATEN_ERMITTELT: {
      const actionPayload: GisDatenErmitteltPayload = action.payload;
      const gisDaten = actionPayload.gisDaten;
      return {
        ...sectionState,
        ...gisDaten,
        latitude: gisDaten?.latitude ? gisDaten.latitude : sectionState?.latitude,
        longitude: gisDaten?.longitude ? gisDaten.longitude : sectionState?.longitude,
        matchcode: gisDaten?.matchcode ? gisDaten.matchcode : sectionState?.matchcode,
      };
    }
    case GlobalActions.PREISE_STRECKE_ERMITTELT: {
      const actionPayload: PreiseStreckeErmittelt = action.payload;
      const taasResponsePayload = actionPayload.taasResponsePayload;
      if (
        actionPayload.appId === App.VHV_V2 &&
        state.angebotsId === actionPayload.angebotsId &&
        taasResponsePayload?.gisDaten
      ) {
        return {
          ...sectionState,
          ...actionPayload.taasResponsePayload.gisDaten,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VHV_V2 && actionPayload.angebotsId === state.angebotsId) {
        return {
          ...sectionState,
          ...actionPayload.gisDaten,
          latitude: null,
          longitude: null,
          matchcode: null,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
